"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

require("./BlogSearch.css");

var _proptypes = require("../../../../utils/proptypes");

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var BlogSearch = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(BlogSearch, _React$PureComponent);

  var _super = _createSuper(BlogSearch);

  function BlogSearch() {
    (0, _classCallCheck2["default"])(this, BlogSearch);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(BlogSearch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onResultSelect = _this$props.onResultSelect,
          onSearchChange = _this$props.onSearchChange,
          searchResults = _this$props.searchResults,
          loading = _this$props.loading;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "blog-search"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Search, {
        value: value,
        loading: loading,
        onResultSelect: onResultSelect,
        onSearchChange: onSearchChange,
        results: searchResults.map(function (_ref) {
          var title = _ref.title,
              slug = _ref.slug;
          return {
            title: title,
            slug: slug
          };
        }),
        placeholder: "Search Blog",
        minCharacters: 3,
        showNoResults: false
      }));
    }
  }]);
  return BlogSearch;
}(_react["default"].PureComponent);

exports["default"] = BlogSearch;
BlogSearch.propTypes = {
  value: _propTypes["default"].string,
  onResultSelect: _propTypes["default"].func.isRequired,
  onSearchChange: _propTypes["default"].func.isRequired,
  searchResults: _propTypes["default"].arrayOf(_proptypes.BlogPostPropType),
  loading: _propTypes["default"].bool
};
BlogSearch.defaultProps = {
  value: '',
  searchResults: [],
  loading: false
};